import { fetchData, fetchDataAsync, postData, postDataAsync } from "../Api/Actions";
import {dismissError, reportError, setVisible, setWorkInProgress} from "../Ui/Actions";
import {saveArtusConfiguration, SET_HIDE_TOP_VIEW, setArtus} from "../Artus/Actions";
import get from "lodash/get";
import { saveBertWarehouseConfiguration, setBertWarehouse } from "../BertWarehouse/Actions";
import { saveBertArchiveConfiguration, setBertArchive } from "../BertArchive/Actions";
import {createScreenshot} from "../../Utils/CreateScreenshot";

export const RECEIVE_CONFIGURATION = "CONFIGURATION_RECEIVE_CONFIGURATION";
export const RECEIVE_CONFIGURATION_ERROR = "CONFIGURATION_RECEIVE_CONFIGURATION_ERROR";
export const RESET_CONFIGURATION_ERROR = "CONFIGURATION_RESET_CONFIGURATION_ERROR";
export const SET_LOAD_IDENTIFIER = "CONFIGURATION_SET_LOAD_IDENTIFIER";
export const SET_LOAD_CODE = "CONFIGURATION_SET_LOAD_CODE";
export const RECEIVE_OPTIONS = "CONFIGURATION_RECEIVE_OPTIONS";
export const RECEIVE_CALCULATION = "CONFIGURATION_RECEIVE_CALCULATION";
export const SET_LOADING = "CONFIGURATION_SET_LOADING";
export const RECEIVE_CALCULATION_ERROR = "CONFIGURATION_RECEIVE_CALCULATION_ERROR";
export const RESET_CODE = "CONFIGURATION_RESET_CODE";
export const SET_CONFIGURATION_CHANGED = "CONFIGURATION_SET_CONFIGURATION_CHANGED";

export const RECEIVE_OFFER_REQUEST_SUCCESS = "RECEIVE_OFFER_REQUEST_SUCCESS";
export const RECEIVE_OFFER_REQUEST_ERROR = "RECEIVE_OFFER_REQUEST_ERROR";

export const receiveConfiguration = (data) => async (dispatch) => {
  await dispatch({
    type: RECEIVE_CONFIGURATION,
    data,
  });
  return dispatch(calculatePrice());
};

export const addToCart = (screenshot) => async (dispatch, getState) => {
  const { configuration, configurationChanged } = getState().Configuration;
  if (configurationChanged) {
    await dispatch(resetConfigurationCode());
  }
  const itemIdentifier = configuration && configuration.item ? configuration.item.identifier : "";
  await dispatch({
    type: SET_LOADING,
    data: true,
  });
  await dispatch(
    itemIdentifier.includes("bertWarehouse")
      ? saveBertWarehouseConfiguration("user", screenshot)
      : itemIdentifier.includes("bertArchive")
      ? saveBertArchiveConfiguration("user", screenshot)
      : saveArtusConfiguration("user", screenshot)
  );
  const { shopData } = getState().Configuration.configuration.information;
  window.parent.postMessage({ type: "addToCart", payload: shopData }, "*");
  await dispatch({
    type: SET_LOADING,
    data: false,
  });
};

export const setLoadCode = (loadCode = null) => ({
  type: SET_LOAD_CODE,
  loadCode,
});

export const setLoadIdentifier = (loadIdentifier) => ({
  type: SET_LOAD_IDENTIFIER,
  loadIdentifier,
});

export const receiveConfigurationError = (source, error) => ({
  type: RECEIVE_CONFIGURATION_ERROR,
  source,
  error,
});

export const loadOptions = (item, key, component) => async (dispatch, getState) => {
  const { configuration } = getState().Configuration;
  return dispatch(
    postData(
      `frontendapi/options/list/${item}/${component}?_channel=_default`,
      {
        configuration: configuration,
      },
      (res) => dispatch(receiveOptions(item, key, res))
    )
  );
};

export const receiveOptions = (item, key, data) => (dispatch) => {
  dispatch({
    type: RECEIVE_OPTIONS,
    key: key,
    options: data,
    item: item,
  });
};

export const receiveCalculation = (json) => ({
  type: RECEIVE_CALCULATION,
  data: json,
  receivedAt: Date.now(),
});

export const receiveCalculationError = (source, error) => ({
  type: RECEIVE_CALCULATION_ERROR,
  source,
  error,
});

export const calculatePrice = () => (dispatch, getState) => {
  const { configuration } = getState().Configuration;
  const itemIdentifier = configuration && configuration.item ? configuration.item.identifier : "";
  if (itemIdentifier.includes("artus")) {
    configuration.customdata.artus = getState().Artus;
  } else if (itemIdentifier.includes("bertWarehouse")) {
    configuration.customdata.bertWarehouse = getState().BertWarehouse;
  } else if (itemIdentifier.includes("bertArchive")) {
    configuration.customdata.bertArchive = getState().BertArchive;
  }
  return dispatch(
    postDataAsync(
      "frontendapi/configurations/price",
      {
        configuration,
        configurationtype: "user",
      },
      receiveCalculation,
      receiveCalculationError
    )
  );
};

export const getConfiguration = (productName) => (dispatch) => {
  dispatch(fetchData(`frontendapi/configuration/loadbyitemidentifier/${productName}`, receiveConfiguration));
};

export const getConfigurationByCode = (code) => (dispatch) => {
  dispatch(
    fetchDataAsync(`frontendapi/configuration/loadbyconfigurationcode/${code}`, receiveProductConfiguration)
  );
};

export const fetchConfigurationByCode = (code) => (dispatch) => {
  return dispatch(
    fetchDataAsync("frontendapi/configuration/loadbyconfigurationcode/" + code, receiveProductConfiguration)
  ).then((success) => {
    dispatch(setWorkInProgress("loadConfiguration", false));
    if (success) {
      dispatch(setVisible("loadConfiguration", false));
    } else {
      throw new Error("Konfiguration wurde nicht gefunden. Bitte überprüfen Sie Ihren Code.");
    }
  });
};

export const resetConfigurationError = () => ({
  type: RESET_CONFIGURATION_ERROR,
});
export const receiveProductConfiguration = (data) => (dispatch, getState) => {
  dispatch(receiveConfiguration(data));
  const itemIdentifier = data.item.identifier;
  if (data.code !== "not_found") {
    const configuration = getState().Configuration.configuration;
    const itemIdentifier = configuration && configuration.item ? configuration.item.identifier : "";
    if (itemIdentifier.includes("artus")) {
      dispatch(setArtus(get(data, "customdata.artus", {})));
    } else if (itemIdentifier.includes("bertWarehouse")) {
      dispatch(setBertWarehouse(get(data, "customdata.bertWarehouse", {})));
    } else if (itemIdentifier.includes("bertArchive")) {
      dispatch(setBertArchive(get(data, "customdata.bertArchive", {})));
    }
    return true;
  }
  return false;
};

export const loadConfiguration = () => async (dispatch, getState) => {
  const { loadCode } = getState().Configuration;
  if (!loadCode) {
    throw new Error("Bitte Code eingeben!");
  }
  dispatch(dismissError());
  dispatch(setWorkInProgress("loadConfiguration", true));

  const success = await dispatch(fetchConfigurationByCode(loadCode));
};

export const resetConfigurationCode = () => ({
  type: RESET_CODE,
});

export const setConfigurationChanged = (changed) => ({
  type: SET_CONFIGURATION_CHANGED,
  changed,
});

export const saveConfiguration = (showSaveConfigurationDialog = true) => async (dispatch, getState) => {
  const state = getState();
  if (state.ui.error) {
    dispatch(dismissError());
  }
  const configuration = state.Configuration.configuration;
  const itemIdentifier = configuration && configuration.item ? configuration.item.identifier : "";
  const screenshot = await createScreenshot(itemIdentifier.includes("artus"));
  dispatch(resetConfigurationCode());
  dispatch(setWorkInProgress("saveConfiguration", true));
  dispatch(setVisible("saveConfiguration", showSaveConfigurationDialog));
  try {
    return dispatch(
        itemIdentifier.includes("bertWarehouse")
            ? saveBertWarehouseConfiguration("user", screenshot)
            : itemIdentifier.includes("bertArchive")
                ? saveBertArchiveConfiguration("user", screenshot)
                : saveArtusConfiguration("user", screenshot)
    );
  } catch (e) {
    dispatch(reportError("Konnte die Konfiguration nicht speichern."));
  }
};


const receiveOfferRequestSuccess = () => (dispatch) => {
  dispatch({
    type: RECEIVE_OFFER_REQUEST_SUCCESS,
  });
}

const receiveOfferRequestError = () => (dispatch) => {
  dispatch({
    type: RECEIVE_OFFER_REQUEST_ERROR,
  });
}

export const sendReceiveOfferRequest = (formData) => async (dispatch) => {

  if (formData.hasError) {
    return false;
  }

  let saveResult;

  try {
    dispatch({
      type: SET_LOADING,
      data: true,
    });
    saveResult = await dispatch(saveConfiguration(false));

  } catch (e) {
    return false;
  } finally {
    dispatch({
      type: SET_LOADING,
      data: false,
    });
  }

  const code = saveResult?.data?.configurationCode;

  if (!code) {
    return false;
  }

  try {
    await dispatch(postDataAsync(
      `frontendapi/receiveoffers/request`,
      {
        configurationCode: code,
        emailAddress: formData.email,
        name: formData.name,
        company: formData.company,
        phoneNumber: formData.phonenumber,
        street: formData.street,
        zip: formData.zip,
        city: formData.city,
        country: formData.country,
      },
      receiveOfferRequestSuccess,
      receiveOfferRequestError
    ));
  } catch (error) {
    return false;
  }
  return true;
}

